import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { VisAxis, VisGroupedBar, VisTooltip, VisXYContainer } from "@unovis/react";
import { FormattedMessage } from "react-intl";

type DataRecord = {
	day: string;
	errors: number;
};

const data: DataRecord[] = [
	{ day: "Mon", errors: 620 },
	{ day: "Tue", errors: 540 },
	{ day: "Wed", errors: 710 },
	{ day: "Thu", errors: 480 },
	{ day: "Fri", errors: 510 },
	{ day: "Sat", errors: 390 },
	{ day: "Sun", errors: 460 },
];

const x = (_: DataRecord, i: number) => i;
const y = (d: DataRecord) => d.errors;

export function ErrorsChart() {
	return (
		<Card>
			<CardHeader>
				<CardTitle>
					<FormattedMessage id="dashboard.errorsChart.title" defaultMessage="Errors per day" />
				</CardTitle>
				<CardDescription>
					<FormattedMessage
						id="dashboard.errorsChart.description"
						defaultMessage="4xx and 5xx responses"
					/>
				</CardDescription>
			</CardHeader>
			<CardContent>
				<VisXYContainer data={data} height={280}>
					<VisGroupedBar x={x} y={y} color="var(--destructive)" />
					<VisAxis
						type="x"
						tickFormat={(_: number | Date, i: number) => data[i]?.day ?? ""}
						gridLine={false}
						tickLine={false}
					/>
					<VisAxis
						type="y"
						tickFormat={(v: number | Date) => String(v)}
						gridLine={true}
						tickLine={false}
					/>
					<VisTooltip />
				</VisXYContainer>
			</CardContent>
		</Card>
	);
}
